import React, { useState, useEffect } from 'react';
import { useAsyncRetry, } from 'react-use';
import { Verifyok } from '../../icons/'

import api from '../../api';
import { Button, Spinner } from 'react-bootstrap';
import ReactInputVerificationCode from 'react-input-verification-code';





import classNames from 'classnames/bind';
import style from './index.module.css';
const cx = classNames.bind(style);

export interface VerifyProps {
  showMsg: (msg: string) => void;
  VerifyCheckRetry: () => void;
  defauleCuid: string | null;
  phoneIsVerify: boolean;
  w1: string;
  m2: string;
  VerifyCheckLoading: boolean;

  // verified: string[],
  // remindmsg: string[],
}



const Verify: React.FC<VerifyProps> = ({
  phoneIsVerify,
  showMsg,
  VerifyCheckRetry,
  defauleCuid,
  w1,
  m2,
  VerifyCheckLoading
}) => {

  React.useEffect(() => { (window.parent as any).resizeIframe() }, [VerifyCheckLoading])
  const [verify, setVerify] = useState<boolean>(false);

  const [cansendSMS, setCanSendSMS] = useState<boolean>(true);
  const [canVerify, setCanVerify] = useState<boolean>(false);
  const [smsCode, setSmsCode] = useState<null | string>(null);


  const [sendSMStimeLeft, setSendSMSTimeLeft] = useState<null | number>(null);
  const [sendVerifytimeLeft, setSendVerifyTimeLeft] = useState<null | number>(null);

  const handleOnCompleted = (e: string) => {
    const codeIsNumber = !e.includes(" ")
    // console.log("codeIsNumber", codeIsNumber, e)
    setSmsCode(e)
    if (codeIsNumber) {
      setCanVerify(true)
      return
    }
    setCanVerify(false)

  }
  const handleOnSendSMS = (cuid: string) => {
    // console.log("SendSMS", cuid, smsCode)
    if (cuid === null) { return }
    api.verifyApply({ cu_id: cuid, v_type: 1 }).then((e) => {
      console.log("SendSMSApplyed", e)
      const time = e?.timeout || Number(process.env.REACT_APP_VERIFY_APPLY_TIMEOUT)
      setSendSMSTimeLeft(time)
    })
    setCanSendSMS(false)
  }
  const handleOnSendVerify = (cuid: string) => {
    // console.log("SendVerify", cuid, smsCode)
    const v_code = smsCode ? smsCode.toString() : ""
    if (cuid === null) { return }
    api.verifyCode({ cu_id: cuid, v_type: 1, v_code: v_code }).then((e) => {
      // console.log("SendVerify", e)
      const time = e?.timeout || Number(process.env.REACT_APP_VERIFY_CODE_TIMEOUT)
      setSendVerifyTimeLeft(time)
      if (e?.err === "0000") {
        VerifyCheckRetry()
      }
    })
    setCanVerify(false)
  }

  React.useEffect(() => {
    if (sendSMStimeLeft === 0) {
      setSendSMSTimeLeft(null)
      setCanSendSMS(true)
    }
    if (!sendSMStimeLeft) return;
    const intervalId = setInterval(() => {
      setSendSMSTimeLeft(sendSMStimeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [sendSMStimeLeft]);

  React.useEffect(() => {
    if (sendVerifytimeLeft === 0) {
      setSendVerifyTimeLeft(null)
      setCanVerify(true)
    }
    if (!sendVerifytimeLeft) return;
    const intervalId = setInterval(() => {
      setSendVerifyTimeLeft(sendVerifytimeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [sendVerifytimeLeft]);

  React.useEffect(() => {
    //避免disable del sms code 仍可以按按鈕問題
    if (smsCode && smsCode.includes(" ")) {
      setCanVerify(false)
      return
    }
  }, [smsCode, sendVerifytimeLeft]);

  return (
    <div className={cx('container')}>
      <div className={cx("text-color", "container-left")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
          <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
        </svg>
        手機驗證
      </div>
      {VerifyCheckLoading ? <Spinner animation="border" variant="danger" />
        : phoneIsVerify ? <div className={cx("wrap")}>
          <Button className={cx("verifypass")}><Verifyok /> 手機驗證成功</Button>
        </div> : <>
          <div className={cx("wrap")}>
            <ul className={cx("tip", "list-decimal")} style={{ padding: "0" }}>
              <li className={cx("list")}>步驟1. 按下「領取驗證碼」，驗證碼將發送到註冊帳戶時輸入的手機號碼，請留意手機訊息</li>
              <li className={cx("list")}>步驟2. 收到簡訊後，請將簡訊內6位數驗證碼，輸入到輸入框</li>
              <li className={cx("list")}>步驟3. 按下「驗證帳戶」，進行驗證</li>
              <li className={cx("list")}>註：本驗證碼自發送起5分鐘內有效，逾時失效。超過5分鐘請回步驟1 重新領取驗證碼</li>
            </ul>
          </div>
          <div className={cx("wrap")}>
            <Button className={cx("btn-verify")} onClick={() => { defauleCuid && handleOnSendSMS(defauleCuid) }} disabled={!!sendSMStimeLeft || !cansendSMS}> {sendSMStimeLeft ? `重新發送(${sendSMStimeLeft})` : "領取驗證碼"}</Button>
          </div>
          <div className={cx("wrap")}>
            <div className={cx("inputVerify")}>
              <ReactInputVerificationCode length={6} placeholder=" " onChange={(e) => {
                handleOnCompleted(e)
              }} />
            </div>
            <Button className={cx("btn-verify")} onClick={() => { defauleCuid && handleOnSendVerify(defauleCuid) }} disabled={!!sendVerifytimeLeft || !canVerify}> {sendVerifytimeLeft ? `重新驗證(${sendVerifytimeLeft})` : "驗證帳戶"}</Button>
          </div>
        </>}

      <div className={cx("wrap")}>
        {m2}
      </div>

    </div >

  );
};


export default Verify;
